import { WithSkeleton } from '@capsicum/common';

import { NCWalletTokenCardsComponent } from './NCWalletTokenCardsComponent';
import { NCWalletTokenCardsSkeleton } from './NCWalletTokenCardsSkeleton';

export const NCWalletTokenCards = WithSkeleton(NCWalletTokenCardsComponent, NCWalletTokenCardsSkeleton);
